import { Link } from "react-router-dom";

export const Shell = ({ children, right = null }) => {
  return (
    <div className="min-h-screen text-white dxc-tick" data-testid="app-shell">
      <header className="border-b border-white/15 sticky top-0 z-40 bg-[#050505]/95 backdrop-blur-sm">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
            <div className="w-9 h-9 border border-white/40 flex items-center justify-center">
              <span className="font-mono-data text-[10px] tracking-widest">DXC</span>
            </div>
            <div className="leading-tight">
              <div className="font-serif-display italic text-lg">Diagnostic</div>
              <div className="font-mono-data text-[10px] tracking-[0.3em] text-white/60 -mt-0.5">
                COST&nbsp;/&nbsp;CHALLENGE
              </div>
            </div>
          </Link>
          <div className="flex items-center gap-3">{right}</div>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">{children}</main>
      <footer className="border-t border-white/10 mt-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex justify-between text-[11px] font-mono-data text-white/40 tracking-widest">
          <span>DXC / v1.0</span>
          <span>TRAIN SMART. SPEND SMART.</span>
        </div>
      </footer>
    </div>
  );
};

export const StatBox = ({ label, value, testId, tone = "default", mono = true }) => {
  const toneCls = tone === "volt"
    ? "text-[color:var(--dxc-volt)]"
    : tone === "red"
      ? "text-[color:var(--dxc-signal)]"
      : "text-white";
  return (
    <div className="dxc-card p-5" data-testid={testId}>
      <div className="font-mono-data text-[10px] tracking-[0.25em] text-white/50 uppercase">
        {label}
      </div>
      <div className={`mt-2 ${mono ? "font-mono-data" : "font-serif-display"} text-3xl ${toneCls}`}>
        {value}
      </div>
    </div>
  );
};

export const SectionTitle = ({ eyebrow, title, testId }) => (
  <div className="mb-6" data-testid={testId}>
    {eyebrow && (
      <div className="font-mono-data text-[10px] tracking-[0.3em] text-white/50 uppercase">
        {eyebrow}
      </div>
    )}
    <h2 className="font-serif-display text-3xl md:text-4xl mt-1">{title}</h2>
  </div>
);
